import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3a1269be"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "dropdown guest-settings-dropdown",
  "data-test": "guest-settings-dropdown"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "dropdown-toggle",
  "data-toggle": "dropdown",
  role: "button",
  "aria-haspopup": "true"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-cog" })
], -1))
const _hoisted_3 = { class: "dropdown-menu" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  "data-test": "foundations-session-button",
  href: "/foundations/"
}, "Continue your Gyre journey", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    "data-test": "my-account-button",
    href: "/myaccount/"
  }, "My Account")
], -1))

import logOut from "../services/utilities/log-out";


export default /*#__PURE__*/_defineComponent({
  __name: 'guest-settings-dropdown',
  props: {
    showLinkToFoundationsSession: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

function logOff(): void {
  logOut();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (props.showLinkToFoundationsSession)
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, _hoisted_6))
        : _createCommentVNode("", true),
      _hoisted_7,
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          "data-test": "log-off-button",
          tabindex: "0",
          style: {"cursor":"pointer"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (logOff()))
        }, " Log off ")
      ])
    ])
  ]))
}
}

})